import "./MoreTagsButton.scss";

import CrossIcon from "components/icons/Components/CrossIcon";

export const LessTagsButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button className="less moreTags" onClick={props.onClick}>
      <CrossIcon/>
    </button>
  );
};
